import React from 'react';
import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <main className="container" style={{ paddingTop: '10rem', paddingBottom: '6rem', minHeight: '60vh' }}>
      <h1>Page not found</h1>
      <p>We couldn't find that page. Explore our school or contact us for help.</p>
      <Link to="/" className="btn btn-gold">Back to Home</Link>
    </main>
  );
}
